import { render, staticRenderFns } from "./AltTextField.vue?vue&type=template&id=6d4eb12b&scoped=true&lang=pug&"
import script from "./AltTextField.vue?vue&type=script&lang=js&"
export * from "./AltTextField.vue?vue&type=script&lang=js&"
import style0 from "./AltTextField.vue?vue&type=style&index=0&id=6d4eb12b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4eb12b",
  null
  
)

/* custom blocks */
import block0 from "./AltTextField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports